<div class="task-list-container">
  <app-home-task-list-item
    *ngFor="let taskItem of taskItems"
    class="task-list-item"
    [taskItem]="taskItem"
    [trackingScreenName]="trackingScreenName"
    (taskItemClick)="onTaskItemClick(taskItem)"
    (taskItemDismiss)="taskItemDismiss.emit(taskItem)"
  >
  </app-home-task-list-item>
</div>
